import { prefixLanguage } from './LANG'

const restAPI = '/api/v1/'

const restPrefixAPI = url => prefixLanguage(restAPI + url)

const ENDPOINTS = {
  /** Community. */
  LOGIN: restPrefixAPI('cabinet/login/'),
  LOGOUT: restPrefixAPI('cabinet/logout/'),
  RESTORE: restPrefixAPI('cabinet/password/reset/'),
  NEW_PASSWORD: restPrefixAPI('cabinet/password/reset/confirm/'),

  /** Statistics. */
  STATISTICS: restPrefixAPI('cabinet/orders-week/'),
  WEEK_INFO: restPrefixAPI('cabinet/info-week/'),
  SEND_SMS: restPrefixAPI('cabinet/send-sms/'),
  SERVICES: restPrefixAPI('request/services/'),
  CREATE_QUOTE: restPrefixAPI('cabinet/create-request/'),
  ORDER_CREATE: restPrefixAPI('cabinet/order-create/'),
  EMPLOYEE: restPrefixAPI('cabinet/get-employee/'),

  /** Order statistics. */
  ORDER_STATISTICS: restPrefixAPI('cabinet/statistic-not-fit-price/'),
  MANUFACTURER: restPrefixAPI('cabinet/get-car-manufacturer/'),
  MODEL_ITEMS: restPrefixAPI('cabinet/get-car-model/{manufacturer}/'),

  /** History. */
  ORDERS_HISTORY: restPrefixAPI('cabinet/orders-history/'),
  ORDERS_STATUS: restPrefixAPI('cabinet/get-order-status-list/'),
  BALANCE_HISTORY: restPrefixAPI('cabinet/balance-history/'),
  BALANCE_DETAILS: restPrefixAPI('cabinet/order-detail/{pk}/'),

  /** Withdraw. */
  DRAW_BALANCE: restPrefixAPI('cabinet/get-balance/'),
  DRAW_OUTPUT: restPrefixAPI('cabinet/withdraw-create/'),
  DRAW_HISTORY: restPrefixAPI('cabinet/withdraw-history/'),
  DRAW_STATUS: restPrefixAPI('cabinet/get-withdraw-status-list/'),

  /** Settings. */
  PROFILE_INFO: restPrefixAPI('cabinet/profile-info/'),
  COMMON_CHANGE: restPrefixAPI('cabinet/profile-update/'),
  EMAIL_CHANGE: restPrefixAPI('cabinet/change-email/'),
  TEST_EMAIL: restPrefixAPI('cabinet/send-test-email/'),
  PASS_CHANGE: restPrefixAPI('cabinet/password-change/'),
}

export { ENDPOINTS }



// WEBPACK FOOTER //
// ./src/js/resources/ENDPOINTS.js